import React, { Fragment } from "react";
import { connect } from "react-redux";
import { PIDCard, PIDLegendTableRow } from "./PIDComponents";
import { PIDCategories } from "./PIDCategories";
import { PIDData } from "./PIDData";
import { Stage, Layer, Image, Transformer } from "react-konva";
import useImage from "use-image";
import FluidCodesModal from "./FluidCodeTable";
import FluidCodesTable from "./FluidCodeTable";
import PipeSpecTable from "./PipeSpecTable";

class PidLegend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <div
          className="modal modal-page fade"
          id="PID"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="pageModalLabel"
          data-animation="false"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        data-keyboard="true"
                        aria-label="Close"
                      >
                        <span>Close</span>
                      </button>
                      <h4 className="modal-title" id="pageModalLabel">
                        P&ID Legend
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-body">
                <div>
                  <div className="row">
                    <div className="col">
                      <div className="row d-flex justify-content-center align-items-center">
                        <h2>P&ID Symbols</h2>
                      </div>
                      <div id="accordion" className="accordion">
                        {PIDCategories.map((category) => (
                          <PIDCard
                            key={"Legend" + category.title}
                            headingId={category.heading}
                            dataTarget={category.dataTarget}
                            ariaControls={category.ariaControls}
                            title={category.title}
                          >
                            {PIDData.map((data, i) => {
                              return data.group === category.title ? (
                                <PIDLegendTableRow
                                  key={"Legend" + data.id}
                                  rowNo={i + 1} // do we actually need this if we have a filter?
                                  src={data.src}
                                  title={data.category}
                                  StaticProps1={data.StaticProps1}
                                  StaticProps2={data.StaticProps2}
                                  StaticProps3={data.StaticProps3}
                                  StaticProps4={data.StaticProps4}
                                  StaticProps5={data.StaticProps5}
                                  StaticProps6={data.StaticProps6}
                                  StaticProps7={data.StaticProps7}
                                />
                              ) : (
                                <Fragment key={data.id}></Fragment>
                              );
                            })}
                          </PIDCard>
                        ))}
                      </div>
                    </div>
                    <div className="col">
                      <div className="row d-flex justify-content-center align-items-center">
                        <h2>Fluid Codes</h2>
                      </div>
                      <div id="accordion" className="accordion">
                        <div className="card">
                          <div className="card-header" id="headingOne">
                            <a
                              className=""
                              data-toggle="collapse"
                              data-target="#fluidCodes"
                              aria-expanded="false"
                              aria-controls="fluidCodes"
                              href="/"
                            >
                              Fluid Codes
                            </a>
                          </div>
                          <div
                            id="fluidCodes"
                            className="collapse"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div
                              className="card-body"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <FluidCodesTable />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="row d-flex justify-content-center align-items-center">
                        <h2>Pipe Specs</h2>
                      </div>
                      <div id="accordion" className="accordion">
                        <div className="card">
                          <div className="card-header" id="headingOne">
                            <a
                              className=""
                              data-toggle="collapse"
                              data-target="#pipeSpecs"
                              aria-expanded="false"
                              aria-controls="pipeSpecs"
                              href="/"
                            >
                              Pipe Specs
                            </a>
                          </div>
                          <div
                            id="pipeSpecs"
                            className="collapse"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div
                              className="card-body"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <PipeSpecTable />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default connect()(PidLegend);
